// Create the media library
function createMediaLibrary(type, selectMedia, categories) {
  // Target
  var mlTarget = $('main');

  if (selectMedia) {
    var overlayWrapper = $('<div class="media-library__overlay-wrapper"/>');
    overlayWrapper.appendTo(mlTarget);

    var overlayContainer = $('<div class="media-library__overlay-container"/>');
    overlayContainer.appendTo(overlayWrapper);

    mlTarget = overlayContainer;

    $('body').addClass('block-scroll');
  }

  // Wrapper
  var mlWrapper = $('<div class="media-library__wrapper"/>');
  mlWrapper.attr('data-type', type);
  mlWrapper.attr('data-select-media', selectMedia ? 1 : 0);
  mlWrapper.appendTo(mlTarget);
  setMediaLibraryView();

  var mlContainer = $('<div class="media-library__container"/>');
  mlContainer.appendTo(mlWrapper);

  // Header
  var mlHeaderWrapper = $(
    '<div class="content-header__wrapper content-header__wrapper--media-library"/>'
  );
  mlHeaderWrapper.appendTo(mlContainer);

  var mlHeaderPlaceholderWrapper = $(
    '<div class="content-header__placeholder"/>'
  );
  mlHeaderPlaceholderWrapper.appendTo(mlContainer);

  var mlHeaderContainer = $('<div class="content-header__container"/>');
  mlHeaderContainer.appendTo(mlHeaderWrapper);

  var mlHeaderTitle = $('<div class="content-header__title"/>');
  mlHeaderTitle.appendTo(mlHeaderContainer);
  mlHeaderTitle.html('<h1>Mediathek</h1>');

  var mlHeaderActionsContainer = $('<div class="content-header__actions"/>');
  mlHeaderActionsContainer.appendTo(mlHeaderContainer);

  if (!selectMedia) {
    var mlHeaderActionAdd = $('<a class="content-header__action icon-link"/>');
    mlHeaderActionAdd.attr('href', '/admin/media/' + type + '/edit');
    mlHeaderActionAdd.attr(
      'data-tooltip-navbar',
      (type == 'image' ? 'Bild' : 'Dokument') + ' hinzufügen'
    );
    mlHeaderActionAdd.html(
      '<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"></path></svg>'
    );
    mlHeaderActionAdd.appendTo(mlHeaderActionsContainer);

    var mlHeaderActionSettings = $(
      '<a class="content-header__action icon-link"/>'
    );
    mlHeaderActionSettings.attr('href', '/admin/media/' + type + '/categories');
    mlHeaderActionSettings.attr('data-tooltip-navbar', 'Tags bearbeiten');
    mlHeaderActionSettings.html(
      '<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"><path d="M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7zm-4 6h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z"></path></svg>'
    );
    mlHeaderActionSettings.appendTo(mlHeaderActionsContainer);
  } else {
    var mlHeaderActionClose = $(
      '<div class="content-header__action icon-link"/>'
    );
    mlHeaderActionClose.appendTo(mlHeaderActionsContainer);
    mlHeaderActionClose.attr('data-tooltip-navbar', 'Mediathek schließen');
    mlHeaderActionClose.html(
      '<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"></path></svg>'
    );
    mlHeaderActionClose.on('click', function () {
      closeMediaLibrary();
    });
  }
  app.tooltipNavbar && app.tooltipNavbar.attach();

  // Content
  var mlContentWrapper = $('<div class="media-library__content-wrapper"/>');
  mlContentWrapper.appendTo(mlWrapper);

  if (selectMedia) {
    mlContentWrapper.addClass('content__container');
  }

  // List options: top
  var mlListOptionsWrapper = $(
    '<div class="list-options__wrapper list-options__wrapper--top"/>'
  );
  mlListOptionsWrapper.appendTo(mlContentWrapper);

  var mlListOptionsContainer = $('<div class="list-options__container"/>');
  mlListOptionsContainer.appendTo(mlListOptionsWrapper);

  // Filer values
  var mlFilterInput = $('<input type="hidden" name="filter"/>');
  mlFilterInput.appendTo(mlListOptionsContainer);

  var mlCategoriesInput = $('<input type="hidden" name="category"/>');
  mlCategoriesInput.appendTo(mlListOptionsContainer);

  // View
  var mlListViewButtonList = $(
    '<div class="media-library__list-view-button media-library__list-view-button--list"/>'
  );
  mlListViewButtonList.html(
    '<svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" viewbox="0 0 24 24"><path d="M3,14h4v-4H3V14z M3,19h4v-4H3V19z M3,9h4V5H3V9z M8,14h13v-4H8V14z M8,19h13v-4H8V19z M8,5v4h13V5H8z"/></svg>'
  );
  mlListViewButtonList.on('click', function () {
    setMediaLibraryView('list');
  });
  mlListViewButtonList.attr('data-tooltip-ml-view', 'Listenansicht');
  mlListViewButtonList.appendTo(mlListOptionsContainer);

  var mlListViewButtonGrid = $(
    '<div class="media-library__list-view-button media-library__list-view-button--grid"/>'
  );
  mlListViewButtonGrid.html(
    '<svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" viewbox="0 0 24 24"><path d="M3 9h4V5H3v4zm0 5h4v-4H3v4zm5 0h4v-4H8v4zm5 0h4v-4h-4v4zM8 9h4V5H8v4zm5-4v4h4V5h-4zm5 9h4v-4h-4v4zM3 19h4v-4H3v4zm5 0h4v-4H8v4zm5 0h4v-4h-4v4zm5 0h4v-4h-4v4zm0-14v4h4V5h-4z"/></svg>'
  );
  mlListViewButtonGrid.on('click', function () {
    setMediaLibraryView('grid');
  });
  mlListViewButtonGrid.attr('data-tooltip-ml-view', 'Tabellenansicht');
  mlListViewButtonGrid.appendTo(mlListOptionsContainer);
  app.tooltipMediaLibraryView && app.tooltipMediaLibraryView.attach();

  // Search
  var mlSearchContainer = $('<div class="list-search__container"/>');
  mlSearchContainer.appendTo(mlListOptionsContainer);

  var mlSearchInputText = $('<input type="text" name="search"/>');
  mlSearchInputText.addClass('textfield textfield--small list-search__input');
  mlSearchInputText.attr('placeholder', 'Suchen...');
  mlSearchInputText.on('keypress.triggerRequest', function (e) {
    if (e.which == 13) {
      requestMediaLibraryData();
    }
  });
  mlSearchInputText.appendTo(mlSearchContainer);

  var mlSearchButton = $('<button type="button"/>');
  mlSearchButton.addClass('list-search__button icon-link');
  mlSearchButton.html(
    '<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px"><path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"></path></svg>'
  );
  mlSearchButton.on('click', function () {
    requestMediaLibraryData();
  });
  mlSearchButton.appendTo(mlSearchContainer);

  // Filter
  var mlFiltersContainer = $('<div class="list-filters__container list-filters__container--filters"/>');
  mlFiltersContainer.attr('data-input-name', 'filter');
  mlFiltersContainer.appendTo(mlListOptionsContainer);

  var mlFiltersLabel = $(
    '<div class="list-filters__label textfield textfield--small"/>'
  );
  mlFiltersLabel.appendTo(mlFiltersContainer);

  var mlFiltersLabelText = $(
    '<div class="list-filters__label-text truncate"/>'
  );
  mlFiltersLabelText.attr('data-filter-text-default', 'Verwendung...');
  mlFiltersLabelText.attr('data-filter-text-selected', '{n} Filter');
  mlFiltersLabelText.appendTo(mlFiltersLabel);

  var mlFiltersLabelIcon = $('<div class="list-filters__label-icon"/>');
  mlFiltersLabelIcon.html(
    '<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px"><path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6-1.41-1.41z"></path></svg>'
  );
  mlFiltersLabelIcon.appendTo(mlFiltersLabel);

  var mlFiltersContent = $('<div class="list-filters__content"/>');
  mlFiltersContent.appendTo(mlFiltersContainer);
  mlAddFiltersToForm(mlFiltersContent, [
    [
      {
        filter: 'own',
        label: 'Nur Eigene'
      }
    ],
    [
      {
        filter: 'used',
        label: 'Verwendete'
      },
      {
        filter: 'unused',
        label: 'Nicht verwendete'
      }
    ]
  ]);

  // Categories
  var mlCategoriesContainer = $('<div class="list-filters__container list-filters__container--categories"/>');
  mlCategoriesContainer.attr('data-input-name', 'category');
  mlCategoriesContainer.appendTo(mlListOptionsContainer);

  var mlCategoriesLabel = $(
    '<div class="list-filters__label textfield textfield--small"/>'
  );
  mlCategoriesLabel.appendTo(mlCategoriesContainer);

  var mlCategoriesLabelText = $(
    '<div class="list-filters__label-text truncate"/>'
  );
  mlCategoriesLabelText.attr('data-filter-text-default', 'Tags...');
  mlCategoriesLabelText.attr('data-filter-text-selected', '{n} Tags');
  mlCategoriesLabelText.appendTo(mlCategoriesLabel);

  var mlCategoriesLabelIcon = $('<div class="list-filters__label-icon"/>');
  mlCategoriesLabelIcon.html(
    '<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px"><path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6-1.41-1.41z"></path></svg>'
  );
  mlCategoriesLabelIcon.appendTo(mlCategoriesLabel);

  var mlCategoriesContent = $('<div class="list-filters__content"/>');
  mlCategoriesContent.appendTo(mlCategoriesContainer);

  // Init filters
  initFilters();
  initFilterLabels();

  // Header spacer
  var mlOptionsSpacerContainer = $('<div class="list-options__spacer"/>');
  mlOptionsSpacerContainer.appendTo(mlListOptionsContainer);

  // Add pagination wrapper
  var mlMediaLibraryPaginationWrapper = $(
    '<div class="pagination__wrapper pagination__wrapper--media-library"/>'
  );
  mlMediaLibraryPaginationWrapper.appendTo(mlListOptionsContainer);

  // List notice
  var mlListNoticeWrapper = $('<div class="list-items__notice"/>');
  mlListNoticeWrapper.appendTo(mlContentWrapper);

  // List items
  var mlListWrapper = $('<div class="list-items__wrapper"/>');
  mlListWrapper.attr('data-name-single', type == 'image' ? 'Bild' : 'Dokument');
  mlListWrapper.attr(
    'data-name-plural',
    type == 'image' ? 'Bilder' : 'Dokumente'
  );
  mlListWrapper.appendTo(mlContentWrapper);

  // List header
  var mlListHeaderContainer = $(
    '<div class="list-item__row list-item__row--head"/>'
  );
  mlListHeaderContainer.appendTo(mlListWrapper);

  // List header icon: multiselect
  if (!selectMedia) {
    var mlListHeaderColMultiselect = $(
      '<div class="list-item__icon list-item__icon--multiselect list-item__icon--head"/>'
    );
    mlListHeaderColMultiselect.appendTo(mlListHeaderContainer);
  }

  // List header col: file preview
  var mlListHeaderColFilePreview = $(
    '<div class="list-item__column list-item__column--head"/>'
  );
  var colType = type == 'image' ? 'image' : 'document';
  mlListHeaderColFilePreview.attr('data-type', colType);
  mlListHeaderColFilePreview.attr('data-id', colType);
  mlListHeaderColFilePreview.appendTo(mlListHeaderContainer);

  // List header col: label for grid
  var mlListHeaderColSortLabel = $(
    '<div class="list-item__column list-item__column--head list-item__column--static"/>'
  );
  mlListHeaderColSortLabel.attr('data-type', 'grid-label');
  mlListHeaderColSortLabel.attr('data-id', 'grid-label');
  mlListHeaderColSortLabel.html('Sortierung:');
  mlListHeaderColSortLabel.appendTo(mlListHeaderContainer);

  // List header col: title
  var mlListHeaderColTitle = $(
    '<div class="list-item__column list-item__column--head list-item__column--link"/>'
  );
  mlListHeaderColTitle.attr('data-get-order', '');
  mlListHeaderColTitle.attr('data-type', 'title');
  mlListHeaderColTitle.attr('data-id', 'title');
  mlListHeaderColTitle.attr('data-active', '0');
  mlListHeaderColTitle.attr('data-direction', 'desc');
  mlListHeaderColTitle.append(
    $('<span class="list-item__order-label"/>').html('Titel')
  );
  mlListHeaderColTitle.append(
    $('<span class="list-item__order-indicator"/>').html(
      '<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"><path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6 1.41 1.41z"></path></svg>'
    )
  );
  mlListHeaderColTitle.on('click', function () {
    setMediaLibraryOrder($(this));
    requestMediaLibraryData();
  });
  mlListHeaderColTitle.appendTo(mlListHeaderContainer);

  // List header col: change date
  var mlListHeaderColChanged = $(
    '<div class="list-item__column list-item__column--head list-item__column--link"/>'
  );
  mlListHeaderColChanged.attr('data-get-order', '');
  mlListHeaderColChanged.attr('data-type', 'datetime');
  mlListHeaderColChanged.attr('data-id', 'updated_at');
  mlListHeaderColChanged.attr('data-active', '1');
  mlListHeaderColChanged.attr('data-direction', 'desc');
  mlListHeaderColChanged.append(
    $('<span class="list-item__order-label"/>').html('Geändert')
  );
  mlListHeaderColChanged.append(
    $('<span class="list-item__order-indicator"/>').html(
      '<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"><path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6 1.41 1.41z"></path></svg>'
    )
  );
  mlListHeaderColChanged.on('click', function () {
    setMediaLibraryOrder($(this));
    requestMediaLibraryData();
  });
  mlListHeaderColChanged.appendTo(mlListHeaderContainer);

  // List header icons
  if (type == 'image') {
    mlListHeaderContainer.append(
      $('<div class="list-item__icon list-item__icon--head"/>')
    );
  }

  mlListHeaderContainer.append(
    $('<div class="list-item__icon list-item__icon--head"/>')
  );

  if (!selectMedia) {
    mlListHeaderContainer.append(
      $('<div class="list-item__icon list-item__icon--head"/>')
    );
    mlListHeaderContainer.append(
      $('<div class="list-item__icon list-item__icon--head"/>')
    );
    mlListHeaderContainer.append(
      $('<div class="list-item__icon list-item__icon--head"/>')
    );
  }

  if (selectMedia) {
    var mlListHeaderColSelectMedia = $(
      '<div class="list-item__icon list-item__icon--select-media"/>'
    );
    mlListHeaderColSelectMedia.appendTo(mlListHeaderContainer);
  }

  // List content
  var mlListContainer = $('<div class="list-items__container"/>');
  mlListContainer.appendTo(mlListWrapper);

  // List options: bottom
  var mlListOptionsWrapperBottom = $(
    '<div class="list-options__wrapper list-options__wrapper--bottom"/>'
  );
  mlListOptionsWrapperBottom.appendTo(mlContentWrapper);

  var mlListOptionsContainerBottom = $(
    '<div class="list-options__container"/>'
  );
  mlListOptionsContainerBottom.appendTo(mlListOptionsWrapperBottom);

  // Multiselect
  if (!selectMedia) {
    var mlListOptionsWrapperBottom = $(
      '<div class="list-multiselect__container list-multiselect__container--media-library"/>'
    );
    mlListOptionsWrapperBottom.appendTo(mlListOptionsContainerBottom);

    // Multiselect icons
    var mlMultiselectIconContainer = $(
      '<div class="list-multiselect__checkbox icon-link" onclick="selectItems(this)"/>'
    );
    mlMultiselectIconContainer.attr('data-selected', 'none');

    var mlMultiselectIconsHTML = '';
    mlMultiselectIconsHTML +=
      '<svg class="list-multiselect__checkbox-icon list-multiselect__checkbox-icon--checkbox-blank" xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"><path d="M19 5v14H5V5h14m2-2H3v18h18V3z"></path></svg>';
    mlMultiselectIconsHTML +=
      '<svg class="list-multiselect__checkbox-icon list-multiselect__checkbox-icon--checkbox-checked" xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"><path d="M21 3H3v18h18V3zM10 17l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"></path></svg>';
    mlMultiselectIconsHTML +=
      '<svg class="list-multiselect__checkbox-icon list-multiselect__checkbox-icon--checkbox-indeterminate" xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"><path d="M21 3H3v18h18V3zm-4 10H7v-2h10v2z"></path></svg>';
    mlMultiselectIconContainer.html(mlMultiselectIconsHTML);

    mlMultiselectIconContainer.appendTo(mlListOptionsWrapperBottom);

    // Multiselect label container
    var mlMultiselectLabelContainer = $(
      '<div class="list-multiselect__label-container"/>'
    );
    mlMultiselectLabelContainer.appendTo(mlListOptionsWrapperBottom);

    // Multiselect options
    var mlMultiselectOptionsContainer = $(
      '<div class="list-multiselect__options"/>'
    );
    mlMultiselectOptionsContainer.appendTo(mlMultiselectLabelContainer);

    var model = type == 'image' ? 'Image' : 'Document';
    var mlMultiselectOptionDelete = $(
      '<div class="list-multiselect__option" onclick="deleteItems(\'' +
      model +
      "', true, 'ml-" +
      type +
      '\')"/>'
    );
    mlMultiselectOptionDelete.html('Löschen');
    mlMultiselectOptionDelete.appendTo(mlMultiselectOptionsContainer);

    // Multiselect label
    var mlMultiselctLabelContainer = $(
      '<div class="list-multiselect__label" onclick="toggleMultiselectOptions()"/>'
    );
    mlMultiselctLabelContainer.html(
      'Ausgewählte ' + (type == 'image' ? 'Bilder' : 'Dokumente') + '...'
    );
    mlMultiselctLabelContainer.appendTo(mlMultiselectLabelContainer);
  }

  // Footer spacer
  var mlOptionsFooterSpacerContainer = $('<div class="list-options__spacer"/>');
  mlOptionsFooterSpacerContainer.appendTo(mlListOptionsContainerBottom);

  // Add pagination wrapper: bottom
  var mlMediaLibraryPaginationWrapperBottom = $(
    '<div class="pagination__wrapper pagination__wrapper--media-library"/>'
  );
  mlMediaLibraryPaginationWrapperBottom.appendTo(mlListOptionsContainerBottom);
}
